import { Component, Input } from '@angular/core';
import { CreditReportTradeLine } from '../models/ApplicantDataResponses/credit';

@Component({
  selector: 'app-trade-line-card',
  templateUrl: './trade-line-card.component.html',
  styleUrls: ['./trade-line-card.component.less']
})
export class TradeLineCardComponent {
  @Input() tradeLine : CreditReportTradeLine;

getPmClasses(pm) {
    switch (pm) {
      case '0': {
        return {'grey': true};
        break;
      }
      case '1': {
        return {'green': true};
        break;
      }
      case '2': {
        return {'red': true};
        break;
      }
      case '3': {
        return {'red': true};
        break;
      }
      case '4': {
        return {'red': true};
        break;
      }
      case '5': {
        return {'red': true};
        break;
      }
      case '7': {
        return {'orange': true};
        break;
      }
      case '8': {
        return {'red': true};
        break;
      }
      case '9': {
        return {'red': true};
        break;
      }
      case 'C': {
        return {'green': true};
        break;
      }
      case 'UR': {
        return {'grey': true};
        break;
      }
      case 'X': {
        return {'grey': true};
        break;
      }
      default: {
        return {'grey': true};
        break;
      }
    }
  }
}
